import React from 'react';
import { Bar } from 'react-chartjs-2';
import _ from 'lodash';

class TotalCostPriceChart extends React.Component {

    render() {
        const labels = _.map(this.props.data, x => x.product_reference);

        return (
            <Bar
                data={{
                    labels: labels,
                    datasets: [
                        {
                            label: 'Total Cost',

                            data: _.map(this.props.data, x => x.total_cost),

                            backgroundColor: 'rgba(255, 77, 56, 0.2)',
                            borderColor: 'rgba(255, 77, 56, 1)',
                            borderWidth: 1,
                            hoverBackgroundColor: 'rgba(255, 104, 86, 0.4)',
                            hoverBorderColor: 'rgba(255, 104, 86, 1)',
                        },
                        {
                            label: 'Total Price',

                            data: _.map(this.props.data, x => x.total_price),

                            backgroundColor: 'rgba(0, 216, 117,0.2)',
                            borderColor: 'rgba(0, 216, 117, 1)',
                            borderWidth: 1,
                            hoverBackgroundColor: 'rgba(0, 255, 138,0.4)',
                            hoverBorderColor: 'rgba(0, 255, 138, 1)',
                        }
                    ]
                }}

            />
        );
    }
}

export default TotalCostPriceChart;